import React from 'react'

import PropTypes from 'prop-types'
import { makeCachedStyles } from 'common/inline-styles'

//TODO: This will pull in styles from theme provider - probably
const useStyles = makeCachedStyles((__theme) => ({
    h3: {
        fontFamily: 'Montserrat',
        fontWeight: 400,
        fontSize: '2em',
    },
}))

export const H3 = ({ children, ...rest }) => {
    const classes = useStyles()
    return (
        <h3 className={classes.h3} {...rest}>
            {children}
        </h3>
    )
}

H3.propTypes = {
    children: PropTypes.node.isRequired,
    rest: PropTypes.any,
}
